import { initializeApp, getApps } from 'firebase/app';
import { initializeAuth, browserLocalPersistence, browserSessionPersistence } from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from 'firebase/functions';

// Firebase configuration using environment variables
const firebaseConfig = {
  apiKey: "AIzaSyAFh_vP9yOcUyBsghWZq_1KETR8HYR1nPo",
  authDomain: "costingapp-1fae7.firebaseapp.com",
  projectId: "costingapp-1fae7",
  storageBucket: "costingapp-1fae7.firebasestorage.app",
  messagingSenderId: "441970523875",
  appId: "1:441970523875:web:dc24fa76ff6730b9e24fd6",
  measurementId: "G-1ZS20XY30G"
};

// Initialize Firebase only if it hasn't been initialized yet
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialize Firestore
const db = getFirestore(app);

// Initialize Functions
const functions = getFunctions(app);

// Initialize auth with persistence
const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence, browserSessionPersistence]
});

// Set up token refresh monitoring
auth.onAuthStateChanged(async (user) => {
  if (user) {
    // Set up a timer to refresh the token before it expires
    const refreshToken = setInterval(async () => {
      try {
        // Force token refresh
        await user.getIdToken(true);
      } catch (error) {
        console.error('Token refresh failed:', error);
        // If refresh fails, clear the interval and sign out
        clearInterval(refreshToken);
        await auth.signOut();
        window.location.href = '/?session=expired';
      }
    }, 10 * 60 * 1000); // Check every 10 minutes

    // Clean up on user change/logout
    return () => clearInterval(refreshToken);
  }
});

// Initialize Analytics (only in production)
const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Function to store Stripe customer data
const storeStripeCustomerData = async (userId, stripeData) => {
  try {
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, {
      stripe: {
        customerId: stripeData.customerId,
        subscriptionId: stripeData.subscriptionId,
        plan: stripeData.plan,
        status: stripeData.status,
        lastUpdated: new Date()
      }
    }, { merge: true });
    return true;
  } catch (error) {
    console.error('Error storing Stripe data:', error);
    throw error;
  }
};

// Function to get Stripe customer data
const getStripeCustomerData = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      return userDoc.data().stripe;
    }
    return null;
  } catch (error) {
    console.error('Error getting Stripe data:', error);
    throw error;
  }
};

// Export all Firebase services and functions
export { 
  auth, 
  db, 
  analytics, 
  functions,
  storeStripeCustomerData, 
  getStripeCustomerData 
};

export default app;